import React, {PropTypes} from 'react';
import '../../styles/dashboard/dashboardHeader.css';

const DashboardHeading = () => {

  // let todayDate = new Date();
  // let currentYear = todayDate.getFullYear();
  //
  // let filingPeriodEnd = new Date('07/01/'+currentYear.toString());
  //
  // if(currentYear-1 === 2016){
  //   filingPeriodEnd = new Date('12/16/'+currentYear.toString());
  // }
  //
  // let dayInMs = 1000 * 60 * 60 * 24;
  // let diff_date = (filingPeriodEnd - todayDate) / dayInMs;
  // let daysRemaining = Math.round((filingPeriodEnd - todayDate) / dayInMs);
  return(<div></div>);
  // return (
  //   <div id="dashboard-heading">
  //     <div className="days-left">
  //       {diff_date > 0 &&
  //       <div className="days-left">
  //         {daysRemaining} days left in the {currentYear-1} filing period
  //       </div>
  //     }
  //     {0 >= diff_date &&
  //       <div className="days-left">
  //         Please note that the compliance date for submission has passed. Your submission will be accepted and marked as “late”.
  //       </div>
  //     }
  //     </div>
  //     <h2 id="homepage-instructions">
  //       Get Started Here
  //     </h2>
  //   </div>
  // );
};

DashboardHeading.propTypes = {
  user: PropTypes.object.isRequired
};

export default DashboardHeading;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashboardHeading.js
 **/